import React from 'react';
import { ReferralSignUpInput } from '../ReferralSignUpInput';

export const CommercialNameInput = ({ t, errors, touched, params }) => {
  return (
    <ReferralSignUpInput
      name={params.commercialNameInput.name}
      label={t(params.commercialNameInput.labelText)}
      placeholder={t(params.commercialNameInput.placeholder)}
      errors={errors}
      touched={touched}
    />
  );
};
